<template>
  <page>
    <template slot="content">
      <help-content :title="'「スタート」ボタンをタップしても反応しない'">
        <template slot="content">
          <div class="text">
            ウォーク／ラン機能では走行ルートを記録するため、位置情報へのアクセス権限を許可していただく必要があります。<br><br>
            Androidの場合、「設定＞アプリと通知＞WeRUN＞権限＞位置情報＞常に許可」<br><br>
            iPhoneの場合、「設定＞プライバシー＞位置情報サービス＞WeRUN＞常に」
          </div>
          <img class="picture" src="../assets/images/q_and_a/H38.png">
        </template>
      </help-content>
    </template>
  </page>
</template>

<script>
  import HelpContent from '@/components/HelpContent'
  import Page from '@/components/Page'

  export default {
    components: {
      HelpContent,
      Page
    },
    mounted () {
      window.scrollTo(0, 0)
    }
  }
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/pages/Help38.vue